const initRetailLabel = () => {
  const baseUrl = "https://dhwebservice.co.uk/api/v1/hortihouse";
  const testUrl = "https://test.dhwebservice.co.uk/api/v1/hortihouse";
  const formatter = new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
  });
  const priceUpdaters = document.querySelectorAll("[data-retail-form]"),
    costPrices = document.querySelectorAll("[data-retail-cost]"),
    overrideForm = document.querySelector("[data-retail-admin]"),
    overrideButton = document.querySelector("[data-retail-admin-button]");

  const performFetch = async (
    method = "GET",
    endpoint,
    data,
    responseType = "json"
  ) => {
    let url = `${baseUrl}${endpoint}`;
    const fetchParams = {
      mode: "cors",
      method,
      headers: {
        "Content-Type": "application/json",
        "x-api-key":
          "TkplU01VLUs1UUZkaTNLZXpiTE10QzVZclVnRzdRdU1hckl6T2NjYzZKS1Vua0Iw",
      },
    };
    if (data) {
      if (method === "POST") fetchParams.body = JSON.stringify(data);
      else url += `?${new URLSearchParams(data).toString()}`;
    }

    const response = await fetch(url, fetchParams);
    return responseType === "json"
      ? await response.json()
      : await response.text();
  };

  const updateMargins = () => {
    if (!priceUpdaters.length) return;

    priceUpdaters.forEach((updater) => {
      var costPriceElem = updater
          .closest("[data-retail-updater]")
          .querySelector("[data-retail-cost]"),
        marginElem = updater
          .closest("[data-retail-updater]")
          .querySelector("[data-retail-margin");

      var costPrice = costPriceElem.dataset.netPrice,
        retailPrice = updater.retailPrice.value;

      marginElem.innerText = "";

      if (!costPrice || !retailPrice) {
        return true;
      }

      var margin = (retailPrice / 1.2 - costPrice) / (retailPrice / 1.2);
      marginElem.innerText =
        "Margin: " +
        new Intl.NumberFormat("en-GB", {
          style: "percent",
          maximumSignificantDigits: 4,
        }).format(margin);
      marginElem.style.removeProperty('display');
    });
  };

  const attachUserSelector = () => {
    if (!overrideForm || !overrideButton) return;
    const originalText = overrideButton.textContent;

    if(sessionStorage.getItem("retailLabelCustomer")) {
      window.retailLabelCustomer = JSON.parse(sessionStorage.getItem("retailLabelCustomer"));
    }

    overrideForm.email.value = window.retailLabelCustomer.email;

    overrideForm.addEventListener("submit", async (event) => {
      event.preventDefault();
      overrideForm.email.disabled = true;
      overrideForm.email.readonly = true;
      overrideButton.disabled = true;
      overrideButton.innerText = "Logging in...";

      const { data, errors } = await performFetch(
        "GET",
        "/find-customer",
        { email: overrideForm.email.value },
        "json"
      );
      const id = data?.id ?? null;

      if (errors.length || !id) {
        alert("Unable to login, check email & try again");
        overrideForm.email.disabled = false;
        overrideForm.email.readonly = false;
        overrideButton.disabled = false;
        overrideButton.textContent = originalText;
        return;
      }

      window.retailLabelCustomer = {
        id: id,
        email: overrideForm.email.value,
      };
      sessionStorage.setItem("retailLabelCustomer", JSON.stringify(window.retailLabelCustomer));

      overrideButton.textContent = "Refreshing data...";
      await Promise.all([attachRetailPriceCalculator(), attachUpdaters()]);
      overrideForm.email.disabled = false;
      overrideForm.email.readonly = false;
      overrideButton.disabled = false;
      overrideButton.textContent = originalText;
    });
  };

  const attachRetailPriceToggles = () => {
    if (!priceUpdaters.length) return;

    priceUpdaters.forEach((updater) => {
      updater.priceSetting.forEach((toggle) => {
        toggle.addEventListener("change", (event) => {
          const isPriceFactor = event.target.value === "price-factor";
          updater.retailPrice.readOnly = isPriceFactor;
        });
      });
    });
  };

  const attachCostAndMargins = () => {
    if (!priceUpdaters.length || !costPrices.length) return;

    costPrices.forEach(async (price) => {
      const variant = await spark.getVariant(
        price.dataset.product,
        price.dataset.variant
      );
      if (variant?.price?.net) {
        price.textContent =
          "Cost Price: " + formatter.format(variant.price.net);
        price.dataset.netPrice = variant.price.net;
        price.style.removeProperty('display');
        updateMargins();
      }
    });

    priceUpdaters.forEach((updater) => {
      updater.addEventListener("keyup", () => {
        updateMargins();
      });
    });
  };

  const attachCurrencyInputs = () => {
    if (!priceUpdaters.length) return;

    const currencyInputs = document.querySelectorAll(".rl__currency-input");

    currencyInputs.forEach((parent) => {
      const inputField = parent.querySelector(".field__input");
      inputField.addEventListener("change", () => {
        const value = parseFloat(inputField.value);
        if (!isNaN(value)) {
          inputField.value = value.toFixed(2);
          parent.classList.add("has-value");
        } else {
          parent.classList.remove("has-value");
        }
      });
    });
  };

  const priceUpdaterSubmitEvent = async (event) => {
    event.preventDefault();

    const updater = event.target,
      formButton = updater.querySelector("[data-retail-form-button]"),
      formLog = updater.querySelector("[data-retail-form-status]");

    formButton.disabled = true;
    const formData = Object.fromEntries(new FormData(updater));
    const data = {
      ...formData,
      customerId: window.retailLabelCustomer.id,
      productCode: updater.dataset.sku,
      overridePricingRule: formData.priceSetting === "manual",
    };

    formLog.style.removeProperty('display');
    formLog.textContent = "Requesting update...";

    const { errors } = await performFetch(
      "POST",
      "/customer-product-label",
      data,
      "json"
    );

    if (!errors.length) formLog.textContent = "Done";
    else formLog.textContent = `Error: ${errors.join(", ")}`;

    formButton.disabled = false;
  };

  const attachUpdaters = async () => {
    if (!priceUpdaters.length) return;

    const {
      data: { products },
      readonly,
      errors,
    } = await performFetch(
      "GET",
      "/customer-product-labels",
      { customerId: window.retailLabelCustomer.id },
      "json"
    );

    if (errors.length) {
      alert("Could not fetch pricing rules, reload the page and try again");
      return;
    }

    priceUpdaters.forEach((updater) => {
      updater.style.removeProperty('display');

      const formButton = updater.querySelector("[data-retail-form-button]");

      if (readonly) {
        updater.priceSetting.forEach((toggle) => {
          toggle.disabled = true;
        });
        updater.productBarcode.readOnly = true;
        updater.retailPrice.readOnly = true;
        updater.productDescription.readOnly = true;
        formButton.readOnly = true;
        formButton.disabled = true;
      } else {
        updater.removeEventListener("submit", priceUpdaterSubmitEvent);
        updater.addEventListener("submit", priceUpdaterSubmitEvent);
      }

      updater.retailPrice.value = "";

      products.forEach(
        ({
          productCode,
          productBarcode,
          retailPrice,
          productDescription,
          overridePricingRule,
        }) => {
          if (productCode === updater.dataset.sku) {
            const barcodeEl = updater.productBarcode,
              retailPriceEl = updater.retailPrice,
              productDescEl = updater.productDescription;

            barcodeEl.value = productBarcode;
            barcodeEl.dispatchEvent(new Event("change"));
            retailPriceEl.value = retailPrice;
            retailPriceEl.dispatchEvent(new Event("change"));
            productDescEl.value = productDescription;
            productDescEl.dispatchEvent(new Event("change"));

            if (overridePricingRule === null || overridePricingRule === true) {
              updater.priceSetting[0].checked = true;
              updater.priceSetting[0].dispatchEvent(new Event("change"));
            } else {
              updater.priceSetting[1].checked = true;
              updater.priceSetting[1].dispatchEvent(new Event("change"));
            }
          }
        }
      );

      updateMargins();
    });
  };

  const retailPriceCalculatorSubmitEvent = async (event) => {
    event.preventDefault();

    const form = document.querySelector("[data-retail-calculator]"),
      formButton = document.querySelector("[data-retail-calculator-button]"),
      formLog = document.querySelector("[data-retail-calculator-status]");

    formButton.disabled = true;

    const formData = Object.fromEntries(new FormData(form));
    const data = {
      customerId: window.retailLabelCustomer.id,
      multiplier: parseFloat(formData.multiplier),
      roundingDirection: formData.rounding,
      roundingValues: Object.keys(formData)
        .filter((key) => key.startsWith("roundNearest"))
        .reduce((accumulator, key) => {
          const value = formData[key];
          if (value !== "") accumulator.push(parseFloat(value) * 100);
          return accumulator;
        }, []),
      baseCostPrice: formData.baseCostPrice,
    };

    formLog.style.removeProperty('display');
    formLog.textContent = "Requesting update...";

    const { status, errors } = await performFetch(
      "POST",
      "/customer-pricing-rule",
      data,
      "json"
    );

    if (errors.length) {
      formLog.textContent = `Error: ${errors.join(", ")}`;
    } else {
      formLog.textContent = "Refreshing prices...";
      await attachUpdaters();
      formLog.textContent = "Done";
    }

    formButton.disabled = false;
  };

  const attachRetailPriceCalculator = async () => {
    if (!priceUpdaters.length) return;

    const form = document.querySelector("[data-retail-calculator]"),
      formButton = document.querySelector("[data-retail-calculator-button]"),
      formLog = document.querySelector("[data-retail-calculator-status]");

    form.multiplier.value = "";
    form.rounding[0].checked = false;
    form.rounding[1].checked = false;
    form.baseCostPrice[0].checked = false;
    form.baseCostPrice[1].checked = false;
    [1, 2, 3, 4].forEach((index) => {
      form[`roundNearest${index}`].value = "";
    });

    const {
      data: { multiplier, roundingDirection, roundingValues, baseCostPrice },
      errors,
    } = await performFetch(
      "GET",
      "/customer-pricing-rule",
      { customerId: window.retailLabelCustomer.id },
      "json"
    );

    if (errors.length) {
      formLog.style.removeProperty('display');
      formLog.textContent = "Unable to fetch customer pricing rules";
      return;
    }

    form.multiplier.value = multiplier;
    const roundingDirectionIndex = roundingDirection === "UP" ? 0 : 1;
    form.rounding[roundingDirectionIndex].checked = true;
    form.rounding[roundingDirectionIndex].dispatchEvent(new Event("change"));

    const baseCostPriceIndex = baseCostPrice === "BOX" ? 0 : 1;
    form.baseCostPrice[baseCostPriceIndex].checked = true;
    form.baseCostPrice[baseCostPriceIndex].dispatchEvent(new Event("change"));

    roundingValues?.forEach((value, index) => {
      const input = form[`roundNearest${index + 1}`];
      input.value = parseFloat(value / 100).toFixed(2);
      input.dispatchEvent(new Event("change"));
    });

    form.removeEventListener("submit", retailPriceCalculatorSubmitEvent);
    form.addEventListener("submit", retailPriceCalculatorSubmitEvent);
  };

  const attachOrderSwitcher = () => {
    const retailOrderToggles = document.querySelectorAll('[data-retail-order-toggle]');
    const retailOrders = document.querySelectorAll('[data-retail-order]');

    if(!retailOrderToggles.length || !retailOrders.length) return;

    retailOrderToggles.forEach(toggle => {
      toggle.addEventListener('click', () => {
        const orderId = toggle.getAttribute('data-retail-order-toggle');
        const retailOrder = Array.from(retailOrders).find(
          order => order.getAttribute('data-retail-order') === orderId
        );

        retailOrderToggles.forEach(otherToggle => {
          otherToggle.classList.add('button--secondary');
        });
        retailOrders.forEach(otherOrder => {
          otherOrder.style.display = 'none';
        })

        toggle.classList.remove('button--secondary');
        retailOrder.style.removeProperty('display');
      });
    })
  }

  window.addEventListener("sparkLayerReady", () => {
    attachCostAndMargins();
  });

  attachUserSelector();
  attachRetailPriceToggles();
  attachCurrencyInputs();
  attachUpdaters();
  attachRetailPriceCalculator();
  attachOrderSwitcher();
};

initRetailLabel();